import React, { useEffect, useRef, useState } from 'react';
import { View, ScrollView, StyleSheet, Pressable } from 'react-native';
import { Container, Button, Text } from 'native-base';
import { Dialog, Portal, Paragraph } from 'react-native-paper';
import { useStore } from '../../store/index';
import { useNavigation, useRoute } from '@react-navigation/native';
import ConversationHeaderNew from '../../components/ConversationHeaderNew';
import GroupAvatar from '../../components/ConversationNewComponents/GroupAvatar';
import UserAvatar from '../../components/ConversationNewComponents/UserAvatar';
import SubHeader from '../../components/SubHeader';
import TemplateMessages from '../../components/ConversationNewComponents/TemplateMessages';
import MessageInput from '../../components/ConversationNewComponents/MessageInput';
import Messages from '../../components/ConversationNewComponents/Messages';
import ContainerStyles from '../../components/AccountSettingComponents/containerStyle';
const NewIndex = () => {
  const navigation = useNavigation();
  const [modalVisible, setModalVisible] = useState(false);
  const [inCircleHome, setInCircleHome] = useState(true);
  const currentUserId = useStore((state) => state.currentUserId);
  const screen = useStore(
    (state) => state.screen
  );
  const currentConversationGroup = useStore(
    (state) => state.currentConversationGroup
  );
  const setVipTempleteMessageInput = useStore(
    (state) => state.setVipTempleteMessageInput
  );
  const checkVIPUser = () => {
    if (
      !currentConversationGroup.vip_user_id &&
      currentUserId === currentConversationGroup.created_by
    ) {
      if (inCircleHome) {
        setModalVisible(true);
      }
    }
  };
  const scrollRef = useRef();
  useEffect(() => {
    if (currentConversationGroup) {
      setTimeout(() => makeItSo(), 500);
      setVipTempleteMessageInput('');
      checkVIPUser();
    }
  }, [currentConversationGroup]);
  const makeItSo = () => {
    scrollRef.current.scrollToEnd({ animated: false, duration: 0 });
  };
  const makeItScroll = () => {
    setTimeout(() => makeItSo(), 500);
  };
  useEffect(() => {
    console.warn(screen)
  },[])
  const handleGoToVIP = () => {
    setModalVisible(!modalVisible);
    setInCircleHome(false);
    navigation.navigate("groupSettings", {
      familyName: currentConversationGroup.group_title,
      group: currentConversationGroup,
    });
  };
  
  return (
    <>
      <ConversationHeaderNew />
      <Container
        style={[
          ContainerStyles.container,
          {
            minWidth: '50vw',
            maxWidth: 1160,
            marginLeft: 'auto',
            marginRight: 'auto',
          },
        ]}
      >
        <ScrollView ref={scrollRef}>
          {currentConversationGroup.chat_group_users.items.length > 2 ? (
            <>
              <GroupAvatar />
              <View style={styles.nameView}>
                <SubHeader text={currentConversationGroup.group_title} />
              </View>
            </>
          ) : (
            <>
              <UserAvatar />
              <View style={styles.nameView}>
                {currentConversationGroup.chat_group_users.items.map(
                  (item, i) => {
                    if (item.user.id !== currentUserId) {
                      return <SubHeader key={i} text={currentConversationGroup?.group_title ? currentConversationGroup?.group_title : item.user.first_name} />;
                    }
                  }
                )}
              </View>
            </>
          )}

          <View style={styles.schedule}>
            {currentUserId === currentConversationGroup.created_by && (
              <>
                <Text style={{ fontFamily: 'OPEN-SANS' }}>
                  Want to set up scheduled auto-generated messages?
                </Text>
                <Button
                  rounded
                  dark
                  style={{ marginVertical: 5, alignSelf: 'center' }}
                  onPress={() => {
                    navigation.navigate('schudleAndAutoMessages');
                  }}
                >
                  <Text>Schedule</Text>
                </Button>
              </>
            )}
          </View>
          <View>
            <Messages updateView={makeItScroll} />
          </View>
        </ScrollView>
        <View>
          {currentConversationGroup.vip_user_id === currentUserId && (
            <MessageInput />
          )}

          <TemplateMessages />
        </View>
        <Portal>
        <Dialog
          visible={modalVisible}
          style={{
            backgroundColor: '#fff',
            width: '25vw',
            height: '15vh',
            alignSelf: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <View style={styles.centeredView}>
                <View style={styles.modalView}>
                  <Text style={styles.modalTextLG}>
                    This group doesn't have a VIP
                  </Text>
                  <Text style={styles.modalText}>
                    Go to "Circle Members" in Circle Settings to assign a VIP?
                  </Text>
                  <View style={styles.modalButtonsView}>
                    <Pressable onPress={() => setModalVisible(!modalVisible)}>
                      <Text>Dismiss</Text>
                    </Pressable>
                    <Button rounded dark onPress={() => handleGoToVIP()}>
                      <Text style={{ fontFamily: "OPEN-SANS-BOLD" }}>
                        Go to Settings
                      </Text>
                    </Button>
                  </View>
                </View>
              </View>
            
        </Dialog>
      </Portal>
    
        
      </Container>
    </>
  );
};

export default NewIndex;
const styles = StyleSheet.create({
  nameView: {
    marginVertical: 5,
    alignSelf: 'center',
  },
  schedule: {
    marginVertical: 5,
    alignItems: 'center',
  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 35,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 2,
  },
  textStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  modalTextLG: {
    marginBottom: 15,
    textAlign: "center",
    fontWeight: "bold",
  },
  modalText: {
    marginBottom: 15,
    textAlign: "center",
  },
  modalButtonsView: {
    flexDirection: "row",
    marginVertical: 15,
    alignItems: "center",
    width: 300,
    justifyContent: "space-around",
  },
});
